import React from "react"

import { Icon } from "../../../Icon/Icon"
import { Button } from "../TestimonialsStyles"

export const TestimonialsNavigation = ({ direction, id }) => (
  <Button id={`${id}-${direction}`} position={direction}>
    <Icon name={`chevron${direction}`} width={14} />
  </Button>
)
